<template>
    <section>
        <div class="columns is-mobile is-multiline is-centered">
            <div class="column has-text-centered is-narrow">
                <b-field label="Öffentliche Landingpage?"  class="field-switch-fix">
                    <b-switch v-model="$root.event.landingpage._public"></b-switch>
                </b-field>
            </div>
            <div class="divider"></div>
            <div class="column has-text-centered is-narrow">
                <b-field label="Kalender ausblenden?"  class="field-switch-fix">
                    <b-switch v-model="$root.event.landingpage.hideCalendar"></b-switch>
                </b-field>
            </div>
            <div class="divider"></div>
            <div class="column has-text-centered is-narrow">
                <b-field label="Teaser ausblenden?"  class="field-switch-fix">
                    <b-switch v-model="$root.event.landingpage.hideTeaser"></b-switch>
                </b-field>
            </div>
            <div class="divider"></div>
            <div class="column has-text-centered is-narrow">
                <b-button @click="openPreview()" type="is-success"
                          icon-left="external-link-alt">
                    Vorschau
                </b-button>
            </div>
        </div>
        <hr>
        <b-field horizontal>
            <template slot="label">
                Deaktivieren
                <b-tooltip type="is-light" label="Landingpage bleibt sichtbar, kann aber nicht abgesendet/bearbeitet werden." multilined>
                    <b-icon size="is-small" icon="question-circle" pack="fal"></b-icon>
                </b-tooltip>
            </template>
            <Datepicker :inline="false" v-model="$root.event.landingpage._expire" :max="$root.event.end" placeholder="Bitte auswählen..." icon="calendar-day" pack="fal">
            </Datepicker>
        </b-field>
        <b-field horizontal>
            <template slot="label">
                Primärfarbe Event
                <b-tooltip type="is-light" label="Farbe für Highlights und Formularelemente auf der Landingpage." multilined>
                    <b-icon size="is-small" icon="question-circle" pack="fal"></b-icon>
                </b-tooltip>
            </template>
            <b-input v-model="$root.event.colorsPrimary" placeholder="#184B94" type="color"></b-input>
            <b-input v-model="$root.event.colorsPrimary" placeholder="#184B94"></b-input>
        </b-field>
        <b-field horizontal>
            <template slot="label">
                Teaser Headline
                <b-tooltip type="is-light" label="Headline über dem Teasertext auf der Landingpage." multilined>
                    <b-icon size="is-small" icon="question-circle" pack="fal"></b-icon>
                </b-tooltip>
            </template>
            <b-input :inline="false" v-model="$root.event.landingpage.headDescr" >
            </b-input>
        </b-field>
        <b-field horizontal>
            <template slot="label">
                Teasertext
                <b-tooltip type="is-light" label="Event Beschreibung auf der Landingpage." multilined>
                    <b-icon size="is-small" icon="question-circle" pack="fal"></b-icon>
                </b-tooltip>
            </template>
            <vue-editor
                    v-model="$root.event.description"
                    useCustomImageHandler
                    @image-added="handleImageAdded"
                    :editorToolbar="customToolbar"
                    :customModules="customModulesForEditor"
                    :editorOptions="editorSettings"
                    @blur="saveEvent(true)">

            </vue-editor>
        </b-field>
        <hr>
        <b-field v-for="(input, index) in $root.settings.firms.find(r => r.id == $root.event.firm).htmlInputs" :label="input.label" horizontal class="" >
            <b-input v-if="input.type.includes('input') || input.type.includes('image')" v-model="$root.event.landingpage[input.name]" @blur="saveEvent()" :disabled="input.type.includes('locked')">

            </b-input>
            <b-input v-if="input.type.includes('textarea')" v-model="$root.event.landingpage[input.name]" @blur="saveEvent(true)" :disabled="input.type.includes('locked')" type="textarea">

            </b-input>
            <b-input v-if="input.type.includes('color')" v-model="$root.event.landingpage[input.name]" @blur="saveEvent(true)" :disabled="input.type.includes('locked')" type="color">

            </b-input>
            <b-input v-if="input.type.includes('color')" v-model="$root.event.landingpage[input.name]" @blur="saveEvent(true)" :disabled="input.type.includes('locked')">

            </b-input>
            <p class="control" v-if="input.type.includes('image')">
                <b-upload v-model="files['f'+index]" @input="file => $root.uploadAsset(file,data => $root.event.landingpage[input.name] = data.url)" :disabled="input.type.includes('locked')" >
                    <a class="button is-primary">
                        <b-icon icon="upload"></b-icon>
                        <span>Upload</span>
                    </a>
                </b-upload>
            </p>
            <p class="control" v-if="input.type.includes('image')">
                <b-button type="is-info" @click="() => {isImageModalActive = true;isImageModalActive = $root.event.landingpage[input.name]}">Vorschau</b-button>
            </p>
        </b-field>
        <b-modal :active.sync="isImageModalActive">
            <p class="image">
                <img :src="isImageModalActive">
            </p>
        </b-modal>
    </section>
</template>

<script>
    import ImageResize from 'quill-image-resize-module'

    export default {
        name: 'Landingpage',
        components: {

        },
        props: {

        },
        data() {
            return {
                files: {},
                isImageModalActive: false,
                isImageModalSrc: '',
                editorSettings: {
                    modules: {
                        // imageDrop: true,
                        imageResize: {}
                    }
                },
                customModulesForEditor: [{
                    //     alias: "imageDrop",
                    //     module: ImageDrop
                    // }, {
                    alias: "imageResize",
                    module: ImageResize
                }],
                customToolbar: [
                    [{
                        // header: [false, 1, 2, 3, 4, 5, 6]
                        header: [false, 1, 2]
                    }],
                    // ["bold", "italic", "underline", "strike"], // toggled buttons
                    ["bold", "italic", "underline"], // toggled buttons
                    [{
                        align: ""
                    },
                        {
                            align: "center"
                        },
                        {
                            align: "right"
                        },
                        {
                            align: "justify"
                        }
                    ],
                    ["blockquote", "code-block"],
                    [{
                        list: "ordered"
                    }, {
                        list: "bullet"
                    }, {
                        list: "check"
                    }],
                    [{
                        indent: "-1"
                    }, {
                        indent: "+1"
                    }], // outdent/indent
                    [{
                        color: []
                    }, {
                        background: []
                    }], // dropdown with defaults from theme
                    ["link", "image", "video"],
                    // ["link", "image"],
                    ["clean"]
                ]
            }
        },
        methods: {
            update(id = this.$route.params.id) {

                return true
            },
            saveEvent(silent = false) {
                this.$root.saveEvent(this.$route.params.id, false , !silent)
            },
            handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
                // An example of using FormData
                // NOTE: Your key could be different such as:
                // formData.append('file', file)

                this.$root.uploadAsset(file, data => {
                    Editor.insertEmbed(cursorLocation, "image", data.url);
                    resetUploader();
                })

            },
            openPreview(){
                let url
                url = this.$root.settings.firms.find(f => f.id == this.$root.event.firm).url
                url += this.$root.event.slug + '/'
                url += 'preview/'
                url += this.$root.event.code
                window.open(url, "mwep"+this.$root.event.code)
            }
        },
        created() {
            // fetch the data when the view is created and the data is
            // already being observed
            this.$root.settings.firms.find(r => r.id == this.$root.event.firm).htmlInputs.forEach(r => {
                if (!this.$root.event.landingpage[r.name]) {
                    this.$root.event.landingpage[r.name] = r.default
                } else if (r.type.includes('locked')) {
                    this.$root.event.landingpage[r.name] = r.default
                }
            })
            if (!this.$root.event.landingpage.headDescr) {
                this.$root.event.landingpage.headDescr = ''
            }
                this.update()
            },
            computed: {}

        }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .c-preview {
        width: 50px;
    }

    .hover-rotate-90 .dropdown-trigger .icon i {
        transition: transform .8s ease;
    }

    .hover-rotate-90.is-active .dropdown-trigger .icon i,
    .hover-rotate-90:hover .dropdown-trigger .icon i {
        transform: rotate(90deg);
    }
</style>
